import { openAlert } from '../components/AlertDialog';

export function showGlobalAlert(type, title, msg) {
  return openAlert({ type: (type || 'info').toLowerCase(), title, msg });
}
